(function () {
  'use strict';

  // ===== Countdown =====
  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var raw = (el.getAttribute('data-countdown') || '').trim().replace(' ', 'T');
    var target = new Date(raw).getTime();
    var valueEl = el.querySelector('[data-countdown-value]');
    var hideAtEnd = el.getAttribute('data-countdown-hide-at-end') === 'true';
    if (isNaN(target) || !valueEl) { el.hidden = true; return; }

    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    var tick = function () {
      var diff = target - Date.now();
      if (diff <= 0) {
        valueEl.textContent = '00:00:00';
        if (hideAtEnd) el.hidden = true;
        return false;
      }
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400);
      var h = Math.floor((s % 86400) / 3600);
      var m = Math.floor((s % 3600) / 60);
      var sec = s % 60;
      valueEl.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
      return true;
    };
    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  });

  // ===== Product gallery =====
  document.querySelectorAll('[data-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var thumbs = gallery.querySelectorAll('[data-thumb]');
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (!track) return;

    var goTo = function (i) {
      var count = track.children.length;
      i = Math.max(0, Math.min(count - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    };
    var current = function () {
      return Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    };
    var markActive = function () {
      var i = current();
      thumbs.forEach(function (t, idx) { t.classList.toggle('is-active', idx === i); });
    };

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.getAttribute('data-thumb'), 10)); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(current() - 1); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1); });
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(markActive);
    }, { passive: true });
  });
})();
